import { LineChartData } from './charts/lineChartData'
import { underSample } from './underSample'
import { colors } from '../plugins/vuetify'

export class MEC {
    lineChartData: LineChartData | null

    // TODO: add types
    constructor(mecsFiltered: any[], pnecsFiltered: any) {

        if (mecsFiltered.length) {
            this.lineChartData = new LineChartData()
            this.lineChartData.add(
                underSample(mecsFiltered.map(o => o.v), 1000), // TODO: think about how many pixels are here.
                colors.mecLine
            )

            if (pnecsFiltered && (Object.keys(pnecsFiltered).length === 1)) {
                for (const key in pnecsFiltered) {
                    this.lineChartData.add([pnecsFiltered[key]], colors.pnecLine)
                }
            }

        } else {
            this.lineChartData = null
        }
    }

    hasData() {
        return this.lineChartData ? true : false
    }
}